"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  return document;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-responsive-carousel/lib/js/shims/document.js
// module id = 1108
// module chunks = 0